// pages/monitor/panels/ems/EmsAlarm.js —— 普通储能（能源管家）· 故障告警（基准页，三类型复用）
// 今日告警 / 历史告警 + 设备类型·告警等级·状态筛选 + 原文标题列头 AI 翻译。详见 panels/AlarmView.js。
import React from 'react';
import AlarmView from '../AlarmView';
import { useLang } from '../../consoles/ems/langContext';

const EmsAlarm = () => {
  const { lang } = useLang();
  return <AlarmView lang={lang} />;
};

export default EmsAlarm;